import { gql } from '@apollo/client';

const GET_USER_CLASSROOMS = gql`
  query getUserClassrooms(
    $userId: [Int!]!
    $studentLicensesWhere: LicensesWhereInput!
    $groupsWhere: GroupsWhereInput!
  ) {
    classrooms(
      where: { archived: false }
      whereUser: { id: $userId, status: [ACTIVE, PENDING] }
      orderBy: { field: NAME, direction: ASC }
    ) {
      id
      name
      groups(where: $groupsWhere) {
        id
        name
        groupEnrollments {
          studentId
          student {
            id
            firstName
            lastName
            licenses(where: $studentLicensesWhere) {
              id
              productId
              dateExpiration
              product {
                family {
                  id
                  code
                }
              }
            }
          }
        }
      }
      students {
        id
        firstName
        lastName
        licenses(where: $studentLicensesWhere) {
          id
          productId
          dateExpiration
          product {
            family {
              id
              code
            }
          }
        }
      }
    }
  }
`;

export default GET_USER_CLASSROOMS;
